// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__6mxGA","messages":"Chat_messages__3SRCl","dateDivider":"Chat_dateDivider__2sabE"};